module.exports = __webpack_public_path__ + "static/media/ring.4a70b42d.mp3";